import { EVINCED_SEVERITIES } from '@evinced-private/ui-common';

// Convert severity to CSS class name (handles both "Best Practice" and "bestPractice" formats)
export const getSeverityClass = (severity: string): string => {
	return (
		severity
			// Handle spaces
			.replace(/\s+/g, '-')
			// Handle camelCase (insert dash before uppercase letters)
			.replace(/([a-z])([A-Z])/g, '$1-$2')
			.toLowerCase()
	);
};

// Convert camelCase to proper display format (bestPractice => Best Practice)
export const formatSeverityText = (severity: string): string => {
	return (
		severity
			// Insert space before uppercase letters
			.replace(/([a-z])([A-Z])/g, '$1 $2')
			// Capitalize first letter of each word
			.replace(/\b\w/g, (letter) => letter.toUpperCase())
	);
};

/**
 * Normalizes messy severity strings into EVINCED_SEVERITIES enum values.
 * Handles case-insensitivity, spaces, underscores, and synonyms (e.g., High => Critical).
 */
export const normalizeSeverity = (severity: string): EVINCED_SEVERITIES => {
	if (!severity) {
		return EVINCED_SEVERITIES.NEEDS_REVIEW; // Default fallback
	}

	const normalized = severity.replace(/[_\s]+/g, '').toLowerCase();

	const severityMap: Record<string, EVINCED_SEVERITIES> = {
		critical: EVINCED_SEVERITIES.CRITICAL,
		high: EVINCED_SEVERITIES.CRITICAL,
		serious: EVINCED_SEVERITIES.SERIOUS,
		moderate: EVINCED_SEVERITIES.MODERATE,
		medium: EVINCED_SEVERITIES.MODERATE,
		minor: EVINCED_SEVERITIES.MINOR,
		low: EVINCED_SEVERITIES.MINOR,
		needsreview: EVINCED_SEVERITIES.NEEDS_REVIEW,
		bestpractice: EVINCED_SEVERITIES.BEST_PRACTICE
	};

	if (severityMap[normalized]) {
		return severityMap[normalized];
	}

	// Attempt to find a direct match if not in map
	const entry = Object.values(EVINCED_SEVERITIES).find((value) => {
		return value.replace(/[_\s]+/g, '').toLowerCase() === normalized;
	});

	return entry || EVINCED_SEVERITIES.NEEDS_REVIEW;
};
